import React from 'react';
import { Select, MenuItem } from '@mui/material';

const DropdownfromDatabaseList = ({
  Options,
  option,
  setOptionValue,
  DisplayItem1 = 'DisplayItem1', // Default key names if not provided
  DisplayItem2 = 'DisplayItem2',
  disabled = false, // Default disabled state
  disableLabel, // Optional label for the top item
  allDataLabel, // Optional label for "All Data" item
  onChange, // Optional onChange handler
  showKeyInLabel = false // New prop to toggle showing the key in the label
}) => {
  const handleChange = (e) => {
    const newValue = e.target.value;
    if (onChange) {
      onChange(newValue); // Call the provided onChange handler if it exists
    } else if (setOptionValue) {
      setOptionValue(newValue); // Call setOptionValue if onChange is not provided
    }
  };

  return (
    <Select
      value={option}
      onChange={handleChange}
      style={{ width: '100%' }} // Consider using a CSS class for styling if needed
      disabled={disabled} // Set disabled state based on prop
      size='small'
    >
      {disableLabel && (
        <MenuItem disabled>{disableLabel}</MenuItem> // Render the disable label if provided
      )}
      
      {allDataLabel && (
        <MenuItem value={allDataLabel}>
          {allDataLabel}
        </MenuItem> // Render the "All Data" item if provided
      )}

      {Options && Options.length > 0 ? (
        Options.map((Item) => {
          // Dynamically choose between DisplayItem1 and DisplayItem2
          const itemKey = Item[DisplayItem2] || Item[DisplayItem1];
          const itemValue = Item[DisplayItem2] || Item[DisplayItem1];
          return (
            <MenuItem
              key={itemKey} // Access key dynamically
              value={itemValue} // Keep the key as the value
            >
              {showKeyInLabel
                ? `${Item[DisplayItem1]} (${Item[DisplayItem2]})`
                : Item[DisplayItem1]}
            </MenuItem>
          );
        })
      ) : (
        <MenuItem disabled>No Options available</MenuItem> // Handle empty state
      )}
    </Select>
  );
};

export default DropdownfromDatabaseList;
